angular.module('userSettingsMod')

.controller('applicationsCtrl', ['$scope', async function($scope) {

  $scope.appsList = await gudhub.getAppsList();
	$scope.appsList = $scope.appsList.filter(app => {
		return app.permission != 4 && app.sharing_type == 1;
	})
	$scope.$apply();

}]);
